import { defineMessages } from 'react-intl';

const messages = defineMessages({
  defaultButtonAction: {
    description: 'settings.workflow.defaultAction',
    defaultMessage: 'Adjust Default Button Action',
    id: '5AzAbL',
  },
  defaultUrl: {
    description: "setting that determines where the user's landing page is after logging in",
    defaultMessage: 'Log in directly to',
    id: 'vmnlKI',
  },
  verifyItemsBy: {
    description: 'settings.workflow.verifyItemsBy',
    defaultMessage: 'Scan To Verify Items By',
    id: 'F6LK+c',
  },
  requiredManualConfirmation: {
    description: 'settings.workflow.requiredManualConfirmation',
    defaultMessage: "Scan Workflow - 'Mark as Verified' Step",
    id: 'aq36iG',
  },
  uiTimeFormat: {
    description: 'settings.displayoptions.uiTimeFormat',
    defaultMessage: 'Time Format',
    id: '9wVXWf',
  },
  uiDateFormat: {
    description: 'settings.displayoptions.uiDateFormat',
    defaultMessage: 'Date Format',
    id: 'QNJeMC',
  },
  weeklyDigest: {
    description: 'Would user like to receive weekly digest',
    defaultMessage: 'Receive a weekly digest email',
    id: 'Ixst2b',
  },
  productGridPageSize: {
    description: 'Default page size for the Product Grid',
    defaultMessage: 'Product Grid Page Size',
    id: '9m6p0a',
  },
  inventoryGridPageSize: {
    description: 'Default page size for the Inventory Grid',
    defaultMessage: 'Inventory Grid Page Size',
    id: 'VMQfUH',
  },
  externalInventoryGridPageSize: {
    description: 'Default page size for the External Inventory Grid',
    defaultMessage: 'External Inventory Grid Page Size',
    id: 'TQ2IBI',
  },
  externalInventoryGridDefaultConfig: {
    description: 'Default External Inventory Grid Column Configuration',
    defaultMessage: 'Default External Inventory Grid Column Configuration',
    id: 'c1IYp8',
  },
  productGridDefaultConfig: {
    description: 'Default Product Grid Column Configuration',
    defaultMessage: 'Default Product Grid Column Configuration',
    id: 'uCgYr+',
  },
  reportingCategoriesGridPageSize: {
    description: 'Default page size for the Reporting Categories Grid',
    defaultMessage: 'Reporting Categories Grid Page Size',
    id: 'OzcWM2',
  },
  presetGroupsGridPageSize: {
    description: 'Default page size for the Preset Groups Grid',
    defaultMessage: 'Preset Groups Grid Page Size',
    id: 'TQyZpn',
  },
  purchaseOrdersGridPageSize: {
    description: 'Default page size for the Purchase Orders Grid',
    defaultMessage: 'Purchase Orders Grid Page Size',
    id: 'c2v7GI',
  },
  isQuickshipEnabled: {
    description: 'isQuickshipEnabled user setting description',
    defaultMessage: 'QuickShip Mode Enabled',
    id: 'c1sAIg',
  },
  quickshipShowWarnings: {
    description: 'quickshipShowWarnings user setting description',
    defaultMessage: 'Show Warnings',
    id: '5MV1GY',
  },
  quickshipShowErrors: {
    description: 'quickshipShowErrors user setting description',
    defaultMessage: 'Show Errors',
    id: 'zLLiNp',
  },
  quickshipShowCostSummary: {
    description: 'quickshipShowCostSummary user setting description',
    defaultMessage: 'Show Cost Summary',
    id: 'ttiOL8',
  },
  quickshipShowFundsNeeded: {
    description: 'quickshipShowFundsNeeded user setting description',
    defaultMessage: 'Show when funds are needed',
    id: 'Yjsm2O',
  },
  quickshipShowPrintDialogPreview: {
    description: 'quickshipShowPrintDialogPreview user setting description',
    defaultMessage: 'Show Print Dialog Preview',
    id: 'ZHsbjj',
  },
  quickshipShowLabelBatchStatus: {
    description: 'quickshipShowLabelBatchStatus user setting description',
    defaultMessage: 'Show Label Batch Status',
    id: 'UoHO6z',
  },
  hideCustomerSummaryPopover: {
    description: 'show/hide customer summary on hover user setting description',
    defaultMessage: 'Customer History Popover',
    id: 'z8N/qk',
  },
  hideExternallyChangedOrders: {
    description: 'Label for choosing what should happen when an order/purchase has an updated status',
    defaultMessage: 'When Order Status Changes',
    id: 'W7A5R0',
  },
  persistCombineOrderSelection: {
    description: 'Label for choosing whether to keep orders selected after combining them',
    defaultMessage: 'Combine Order Selection',
    id: 'WsBQP3',
  },
  uspsNsaCopOnboardingCompleted: {
    description: 'Track whether user has completed USPS NSA COP onboarding process',
    defaultMessage: 'USPS NSA COP Onboarding Completed',
    id: 'f/Php3',
  },
  uspsNsaWaitingBannerDismissed: {
    description: 'Track whether user has dismissed USPS NSA waiting for approval banner',
    defaultMessage: 'USPS NSA Waiting Banner Dismissed',
    id: 'gxo/sp',
  },
  uspsNsaModalDismissedAtUTC: {
    description:
      'ISO timestamp of when user last dismissed the USPS NSA modal, compared against lastLoginDate to show once per login session',
    defaultMessage: 'USPS NSA Modal Dismissed At',
    id: 'K4DJEl',
  },
  suppliersGridPageSize: {
    description: 'Default page size for the Suppliers Grid',
    defaultMessage: 'Suppliers Grid Page Size',
    id: '8vZYxd',
  },
  customsDocumentReminderDismissed: {
    description: 'Track whether user has dismissed the post-label customs document upload reminder',
    defaultMessage: 'Customs Document Reminder Dismissed',
    id: 'fCEKtP',
  },
  customsFormViewMode: {
    description: 'User preferred view mode for customs declarations (tab or list)',
    defaultMessage: 'Customs Form View Mode',
    id: 'tNusdo',
  },
  supplierProductsGridPageSize: {
    description: 'Default page size for the Supplier Products Grid',
    defaultMessage: 'Supplier Products Grid Page Size',
    id: '0YgkM0',
  },
});

export const UserSettings = {
  advancedHotkeys: {
    key: 'advancedHotkeys',
    settingName: 'AdvancedHotKeys',
  },
  inventorySmartReorderForecastConfigs: {
    key: 'inventorySmartReorderForecastConfigs',
    settingName: 'inventory.smart_reorder.forecast_configs',
  },
  operationsSnapshotSelectedCards: {
    key: 'operationsSnapshotSelectedCards',
    settingName: 'home.operations_snapshot.selected_cards',
  },
  defaultButtonAction: {
    key: 'defaultButtonAction',
    settingName: 'v3.configureShipmentWidget.actionButton',
  },
  defaultUrl: {
    key: 'defaultUrl',
    settingName: 'DefaultUrl',
  },
  verifyItemsBy: {
    key: 'verifyItemsBy',
    settingName: 'v3.scanToVerify.verifyItemsBy',
  },
  requiredManualConfirmation: {
    key: 'requiredManualConfirmation',
    settingName: 'v3.scanToVerify.requireManualConfirmation',
  },
  uiTimeFormat: {
    key: 'uiTimeFormat',
    settingName: 'UI:TimeFormat',
  },
  uiDateFormat: {
    key: 'uiDateFormat',
    settingName: 'UI:DateFormat',
  },
  weeklyDigest: {
    key: 'weeklyDigest',
    settingName: 'WeeklyDigest',
  },
  productGridPageSize: {
    key: 'productGridPageSize',
    settingName: 'products:grid:pagesize',
  },
  productGridDefaultConfig: {
    key: 'productGridDefaultConfig',
    settingName: 'v3.products.gridConfig.products.default',
  },
  inventoryGridPageSize: {
    key: 'inventoryGridPageSize',
    settingName: 'inventory:grid:pagesize',
  },
  externalInventoryGridPageSize: {
    key: 'externalInventoryGridPageSize',
    settingName: 'external:inventory:grid:pagesize',
  },
  inventoryGridDefaultConfig: {
    key: 'inventoryGridDefaultConfig',
    settingName: 'v3.inventory.gridConfig.inventory.default',
  },
  externalInventoryGridDefaultConfig: {
    key: 'externalInventoryGridDefaultConfig',
    settingName: 'v3.externalInventory.gridConfig.externalinventory.default',
  },
  reportingCategoriesGridPageSize: {
    key: 'reportingCategoriesGridPageSize',
    settingName: 'products:category:grid:pagesize',
  },
  presetGroupsGridPageSize: {
    key: 'presetGroupsGridPageSize',
    settingName: 'products:profile:grid:pagesize',
  },
  purchaseOrdersGridPageSize: {
    key: 'purchaseOrdersGridPageSize',
    settingName: 'purchaseorders:grid:pagesize',
  },
  transferOrdersGridPageSize: {
    key: 'transferOrdersGridPageSize',
    settingName: 'transferorders:grid:pagesize',
  },
  isQuickshipEnabled: {
    key: 'isQuickshipEnabled',
    settingName: 'quickship:isEnabled',
  },
  quickshipShowWarnings: {
    key: 'quickshipShowWarnings',
    settingName: 'quickship:showWarnings',
  },
  quickshipShowErrors: {
    key: 'quickshipShowErrors',
    settingName: 'quickship:showErrors',
  },
  quickshipShowCostSummary: {
    key: 'quickshipShowCostSummary',
    settingName: 'quickship:showCostSummary',
  },
  quickshipShowPrintDialogPreview: {
    key: 'quickshipShowPrintDialogPreview',
    settingName: 'quickship:showPrintDialogPreview',
  },
  quickshipShowLabelBatchStatus: {
    key: 'quickshipShowLabelBatchStatus',
    settingName: 'quickship:showLabelBatchStatus',
  },
  fillTimeSla: {
    key: 'fillTimeSla',
    settingName: 'SLA:fillTimeHours',
  },
  prepayDutyAlert: {
    key: 'prepayDutyAlert',
    settingName: 'prepayDutyAlert',
  },
  hideCustomerSummaryPopover: {
    key: 'hideCustomerSummaryPopover',
    settingName: 'Orders:NoCustomerInformationPopUp',
  },
  ordersGridPageSize: {
    key: 'ordersGridPageSize',
    settingName: 'orders:grid:pagesize',
  },
  shipmentsGridPageSize: {
    key: 'trackShipmentsGridPagesize',
    settingName: 'track:shipments:grid:pagesize',
  },
  hideExternallyChangedOrders: {
    key: 'hideExternallyChangedOrders',
    settingName: 'Orders:HideExternallyChangedOrders',
  },
  shouldPersistCombineOrderSelection: {
    key: 'persistCombineOrderSelection',
    settingName: 'orders:persistCombineOrderSelection',
  },
  uspsNsaCopOnboardingCompleted: {
    key: 'uspsNsaCopOnboardingCompleted',
    settingName: 'uspsNsaCopOnboardingCompleted',
  },
  uspsNsaWaitingBannerDismissed: {
    key: 'uspsNsaWaitingBannerDismissed',
    settingName: 'uspsNsaWaitingBannerDismissed',
  },
  uspsNsaModalDismissedAtUTC: {
    key: 'uspsNsaModalDismissedAtUTC',
    settingName: 'uspsNsaModalDismissedAtUTC',
  },
  fedExNoticeLastDismissedDate: {
    key: 'fedExNoticeLastDismissedDate',
    settingName: 'fedExNoticeLastDismissedDate',
  },
  enhancedReturnsToken: {
    key: 'enhancedReturnsToken',
    settingName: 'EnhancedReturnsToken',
  },
  userHasVerifiedPhoneNumber: {
    key: 'userHasVerifiedPhoneNumber',
    settingName: 'UserHasVerifiedPhoneNumber',
  },
  nonDefaultTermsNoticeLastDismissedDate: {
    key: 'nonDefaultTermsNoticeLastDismissedDate',
    settingName: 'nonDefaultTermsNoticeLastDismissedDate',
  },
  isAmazonShippingFirstLabelCreated: {
    key: 'isAmazonShippingFirstLabelCreated',
    settingName: 'isAmazonShippingFirstLabelCreated',
  },
  orderDetailsCustomLayout: {
    key: 'orderDetailsCustomLayout',
    settingName: 'v3.order.details.custom.layout',
  },
  suppliersGridPageSize: {
    key: 'suppliersGridPageSize',
    settingName: 'suppliers:grid:pagesize',
  },
  phoneNumberCaptureModalDismissed: {
    key: 'phoneNumberCaptureModalDismissed',
    settingName: 'phoneNumberCaptureModalDismissed',
  },
  phoneNumberCaptureBannerDismissed: {
    key: 'phoneNumberCaptureBannerDismissed',
    settingName: 'phoneNumberCaptureBannerDismissed',
  },
  multiPackageUnassignedItemsWarningDismissed: {
    key: 'multiPackageUnassignedItemsWarningDismissed',
    settingName: 'multiPackageUnassignedItemsWarningDismissed',
  },
  multiPackageEmptyPackageWarningDismissed: {
    key: 'multiPackageEmptyPackageWarningDismissed',
    settingName: 'multiPackageEmptyPackageWarningDismissed',
  },
  customsDocumentReminderDismissed: {
    key: 'customsDocumentReminderDismissed',
    settingName: 'customsDocumentReminderDismissed',
  },
  customsFormViewMode: {
    key: 'customsFormViewMode',
    settingName: 'customsFormViewMode',
  },
  planMigrationModalDismissed: {
    key: 'planMigrationModalDismissed',
    settingName: 'planMigrationModalDismissed',
  },
  supplierProductsGridPageSize: {
    key: 'supplierProductsGridPageSize',
    settingName: 'suppliers:products:grid:pagesize',
  },
};

Object.keys(UserSettings).forEach((setting) => {
  UserSettings[setting].messageDescriptor = messages[UserSettings[setting]?.key];
});

// Keyed by each entry's `key`, not its name — a couple differ: shouldPersistCombineOrderSelection is keyed persistCombineOrderSelection.
export const userSettingMessages = messages;

export const quickshipUserSettings = [
  UserSettings.quickshipShowWarnings,
  UserSettings.quickshipShowErrors,
  UserSettings.quickshipShowCostSummary,
  UserSettings.quickshipShowLabelBatchStatus,
  UserSettings.quickshipShowPrintDialogPreview,
];
